import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Cylinder, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 100,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [0.12, 0.12, 1.2, 3], mass: 3, position: [0, 0, 0], rotation: [0, 0, Math.PI / 2], type: 'Cylinder' },
      { args: [0.7, 0.7, 1.0, 6], mass: 12, position: [-1.4, 0, 0], rotation: [0, 0, Math.PI / 2], type: 'Cylinder' },
      { args: [0.7, 0.7, 1.0, 6], mass: 12, position: [1.4, 0, 0], rotation: [0, 0, Math.PI / 2], type: 'Cylinder' }
    ], 
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind =  {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Cylinder position={[0, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.12, 0.12, 2.4, 16]} color="#2a2a2a" />

      <Cylinder position={[-0.4, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.125, 0.125, 0.4, 16]} />
      <Cylinder position={[0.4, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.125, 0.125, 0.4, 16]} />

      <Cylinder position={[-1.4, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.7, 0.7, 1.0, 16]} />
      <Cylinder position={[-1.75, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.55, 0.55, 0.8, 16]} />
      <Cylinder position={[1.4, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.7, 0.7, 1.0, 16]} />
      <Cylinder position={[1.75, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.55, 0.55, 0.8, 16]} />

      <Cylinder position={[-1.4, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.72, 0.72, 0.2, 16]} color="#2a2a2a" />
      <Cylinder position={[1.4, 0, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.72, 0.72, 0.2, 16]} color="#2a2a2a" />
    </group>
  );
};
